$("#close-alert" ).on('click', function() {
	$(this).closest('div.info-box').fadeOut();
});

$('.alert-dismissible .close').on('click',function(){

	var alert = $(this).closest('.alert');
	var container = alert.closest('.alert-container');

	alert.fadeOut(300);
	alert.hide(300);
	window.setTimeout(function() {
		container.remove();
	}, 300);

});